export default {
	termsAndConditions: {
		lastUpdate: 'Última actualización: 10 de Junio de 2024',
		content: `
			<p>Los Términos que encontrará a continuación son importantes porque:</p>
			<ul>
				<li>Establecen sus derechos legales en {siteName}.</li>
				<li>
					Explique los derechos que nos otorga cuando utiliza {siteName} .
				</li>
				<li>
					Describen las reglas que todos deben respetar al usar {siteName}.
				</li>
			</ul>
			<p>
				Lea atentamente estos Términos, así como nuestra {privacyPolicyLink} y
				cualquier otro documento mencionado en estos Términos.
			</p>
			<p>Comencemos...</p>
			<h3>1. INTRODUCCIÓN Y DATOS DE {siteNameUpper}.</h3>
			<p>
				El sitio web {websiteLink} (en adelante, el "Sitio Web") es propiedad de la
				empresa {siteName} S.L (en adelante, el "{siteName}"), sociedad
				constituida de conformidad con legislación española con domicilio en Avenida
				de Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), titular de CIF
				número B-56.768.260 e inscrita en el Registro Mercantil de Barcelona al Tomo
				49065, Folio 0033, Hoja B- 606324, Registro 1º.
			</p>
			<p>
				{siteName} pone el Sitio Web a tu disposición para que puedas conocernos
				mejor, conocer los servicios que prestamos y si lo deseas, puedas contactar y,
				en su caso, contratar con nosotros.
			</p>
			<h3>2. OBJETO Y ÁMBITO DE APLICACIÓN DE LAS CONDICIONES DE USO</h3>
			<p>
				Las presentes condiciones de uso constituyen, junto con la {privacyPolicyLink}
				y el {cookiesPolicyLink}, el marco legal que regula el uso del sitio web
				{websiteLink}. Estas condiciones de uso estarán a tu disposición en la página
				web en inglés para que puedas consultarlas, archivarlas o imprimirlas en
				cualquier momento y cuando quieras.
			</p>
			<p>
				Para conocer cualquier duda relativa al tratamiento realizado por {siteName}.
				de sus datos personales, visite nuestra {privacyPolicyLink} y nuestra
				{cookiesPolicyLink}. Ambas políticas también estarán disponibles para ti en
				inglés para que puedas consultarlas, archivarlas o imprimirlas en cualquier
				momento.<br />{siteName} utiliza cookies de terceros en el Sitio Web.
				Para obtener más información sobre el tipo de cookies utilizadas en la web
				{websiteLink}, su finalidad y cómo configurar su navegador en caso de que no
				desee que utilicemos estas cookies, visite nuestra {cookiesPolicyLink}.
			</p>
			<p>
				Tanto estas condiciones de uso, como el {privacyPolicyLink} y el
				{cookiesPolicyLink} han sido elaborados de conformidad con lo dispuesto en la
				normativa vigente aplicable, entre otras, la Ley 34/2002, de Servicios de la
				Sociedad de la Información y de Comercio Electrónico y Reglamento (UE)
				2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016,
				relativo a la protección de las personas físicas en lo que respecta al
				tratamiento de datos personales y a la libre circulación de estos datos y por
				el que se establece la Directiva 95 /46/CE queda derogado.
			</p>
			<h3>3. ACCESO AL SITIO WEB Y ACEPTACIÓN</h3>
			<p>
				El acceso al Sitio Web es gratuito excepto en la parte relativa al coste del
				conexión a través de la red de telecomunicaciones proporcionada por Internet
				proveedor de acceso que tengas contratado. Puedes navegar libremente por el
				Sitio Web y accede a él tantas veces como quieras. Para acceder y navegar por
				el sitio web, No es necesario registrarse, excepto si desea contratar algún
				servicio.
			</p>
			<p>
				La utilización del sitio web le atribuye la condición de usuario del sitio web
				(en adelante, el “Usuario”) e implica su aceptación plena y sin reservas de
				estas condiciones de uso, así como la {privacyPolicyLink} y la
				{cookiesPolicyLink} del Sitio Web. Además, acepta no utilizar el Servicio con
				fines ilegales. propósitos.
			</p>
			<p>
				Al acceder al Sitio Web y navegar por él, usted declara bajo su
				responsabilidad de que eres mayor de edad y que cuentas con los permisos
				legales necesarios capacidad para acceder al Sitio Web y utilizarlo,
				declarando además que usted plenamente entiende y acepta estas condiciones de
				uso sin reservas.
			</p>
			<p>
				Por otro lado, le informamos que por motivos legales archivamos el Documentos
				electrónicos en los que se formalizan las compras. Puedes acceder estos
				documentos en cualquier momento solicitándolos en: {supportLink}.
			</p>
			<h3>4. CONDICIONES DE USO DEL SITIO WEB</h3>
			<p>
				El Usuario se compromete a utilizar el Sitio Web de conformidad con las
				presentes condiciones de uso, legislación vigente y buena fe. Así, el Usuario
				responderá a {siteName}. y ante cualquier tercero por los daños y
				perjuicios derivados de el uso contrario a las presentes condiciones, a la
				legislación y a la buena fe realizadas por el Usuario del Sitio Web.
			</p>
			<h3>5. DESCRIPCIÓN DEL SERVICIO</h3>
			<p>
				A través del Servicio, {siteName} permite la suscripción al servicio
				para realizar la edición de imágenes.
			</p>
			<p>
				El idioma en el que se celebrará el contrato entre {siteName} y el
				comprador será el del país de origen.<br />El proceso de compra en el servicio
				online será el siguiente:
			</p>
			<ol>
				<li>Deberás registrarte en la web con un usuario y contraseña.</li>
				<li>
					Al momento de registrarse, el usuario deberá seleccionar uno de los planes
					de pago que se encuentran en la sección Precios y se le otorgarán créditos
					dependiendo del plan seleccionado. Cada crédito te permitirá editar una
					imagen.
				</li>
				<li>
					Después de la compra del servicio, el usuario dispondrá de un panel de
					administración donde encontrará:
					<ul>
						<li>
							Una sección con un listado de todas las imágenes que han sido
							procesadas, pudiendo editarlas tantas veces como quieras y descargarlas
							en tu dispositivo.
						</li>
						<li>
							Un apartado de Planes y pagos para consultar las facturas y cancelar la
							suscripción.
						</li>
						<li>
							Una sección de Mi Cuenta para poder cambiar las preferencias de la
							cuenta.
						</li>
					</ul>
				</li>
			</ol>
			<p>
				Una vez realizada la compra del servicio, ésta será confirmada por enviando un
				correo electrónico, en el plazo máximo de 24 horas, a la dirección que haya
				indicado. Se indicará el servicio, cómo cancelar la suscripción, su importe,
				impuestos aplicables, la forma de pago y los términos y condiciones
				aplicables.
			</p>
			<h4>5.1 Suscripción</h4>
			<p>
				La suscripción al servicio varía dependiendo en el plan seleccionado y se
				renovará automáticamente por el mismo período de tiempo hasta su terminación.
				A menos que canceles tu suscripción, nos autorizas a cargar la tarifa de
				suscripción anual correspondiente en tu método de pago.
			</p>
			<p>
				Puedes cancelar tu suscripción al Servicio en cualquier momento, y seguirás
				teniendo acceso al mismo hasta al final de su período de facturación anual. En
				la medida en que lo permita la ley, los pagos no son reembolsables y no
				proporcionamos reembolsos ni créditos por períodos de suscripción anual
				parcial.
			</p>
			<h3>6. PRECIO E IMPUESTOS</h3>
			<p>
				Los precios de los productos ofertados en {siteName} se indican en euros (€)
				o la moneda del país desde el que se realiza la compra, el Impuesto sobre el
				Valor Añadido (IVA) vigente en el el momento de la compra grava el precio de
				los productos.
			</p>
			<p>
				En cualquier caso, la operación podría estar exenta o no sujeta al IVA
				dependiendo de tu país de residencia o de la condición en la que actúes. Por
				este motivo, en algunos casos el precio final del pedido puede verse alterado
				respecto al mostrado.<br />Las compras realizadas por sujetos exentos del pago
				del IVA lo indicarán enviando su número de IVA/NIF por correo electrónico a
				{supportLink} , no registrando compras con dicho impuesto.
			</p>
			<h3>7. FORMA DE PAGO</h3>
			<p>
				El pago online del servicio adquirido podrá realizarse mediante tarjeta de
				crédito o débito. En este sentido, {siteName} informa a los titulares
				de tarjetas de crédito y débito que las transacciones en la tienda online se
				realizan a través de una pasarela de pago segura, utilizando tecnología SSL
				para garantizar la seguridad en la transmisión de datos.
			</p>
			<h3>8. DERECHO DE DESISTIMIENTO Y REEMBOLSOS</h3>
			<h4>8.1. Derecho de desistimiento</h4>
			<p>
				Dado el tipo de producto comercializado en nuestro servicio online, software
				en formato digital de QR, no será aplicable el derecho de desistimiento según
				el artículo 103, letra m) del Real Decreto Legislativo 1/ 2007, de 16 de
				noviembre, por el que se aprueba el texto refundido de la Ley General para la
				Defensa de los Consumidores y Usuarios y otras leyes complementarias.
			</p>
			<h4>8.2. Reembolsos</h4>
			<p>
				Independientemente del plan elegido por el usuario, las cantidades pagadas por
				el usuario y en la medida permitida por la ley no serán reembolsables.
			</p>
			<p>
				El servicio contratado no podrá ser asignado o transferidos a otros usuarios
				del Servicio.
			</p>
			<p>
				En cualquier caso, el usuario podrá hacer uso del servicio contratado hasta la
				finalización del periodo contratado.
			</p>
			<h3>9. VIGENCIA DE LAS OFERTAS</h3>
			<p>
				Los servicios ofrecidos en el Servicio, y sus precios, estarán disponibles
				para su compra mientras se encuentren en el catálogo de servicios mostrados a
				través de este sitio web.
			</p>
			<p>
				En cualquier caso, {siteName} se reserva el derecho de realizar las
				modificaciones que considere oportunas en el Servicio, pudiendo actualizar
				productos y servicios dependiendo del mercado.
			</p>
			<p>
				{siteName} se reserva el derecho de cambiar los precios sin previo
				aviso. Le informamos que a pesar de las actualizaciones que se realicen en los
				precios del Servicio, los mismos podrían contener errores. Corregiremos de
				inmediato cualquier error que aparezca, pero no serán vinculantes para el
				Servicio.
			</p>
			<h3>10. SEGURIDAD</h3>
			<p>
				Como se indicó anteriormente, todo el procedimiento de compra, así como la
				transmisión de sus datos personales y sistemas de pago, se realiza en una
				página segura y de forma cifrada mediante el protocolo SSL.
			</p>
			<p>
				Garantizamos la seguridad del Servicio de acuerdo con los conocimientos
				tecnológicos actuales. Sin embargo, {siteName} no puede garantizar la
				seguridad futura total del Servicio. En cualquier caso, nos comprometemos a
				corregir e implementar las medidas correctivas apropiadas para corregir una
				posible brecha de seguridad lo antes posible.
			</p>
			<p>
				Aceptas notificar a {siteName}, inmediatamente y vía correo electrónico
				{supportLink} de cualquier situación. que podría conducir a la suplantación de
				la identidad de un usuario.
			</p>
			<h3>11. MODIFICACIONES Y NULIDAD</h3>
			<p>
				Podremos actualizar los términos y condiciones del Servicio en el futuro, así
				como las características y funciones del Servicio en sí.
			</p>
			<p>
				Le informaremos de los cambios en los términos y condiciones mediante la
				colocación de un aviso en un lugar destacado de nuestro sitio web y/o por
				correo electrónico.
			</p>
			<p>
				Si cualquier cláusula incluida en estos términos y condiciones fuera
				declarada, total o parcialmente, nula o ineficaz, será sólo afectará a dicha
				disposición o a la parte de la misma que resulte nula o ineficaz. Los términos
				y condiciones subsistirán en todo lo demás, existiendo dicha disposición, o la
				parte de la misma que resulte afectada, por no ser colocada.
			</p>
			<h3>12. RECLAMACIONES Y ACCIONES DERIVADAS DEL CONTRATO</h3>
			<p>
				En la medida de lo posible, este Servicio se rige por la legislación
				española.<br />Con el fin de simplificar la resolución de reclamaciones
				mediante procedimientos civiles y reducir costes, no excluimos la posibilidad
				de someternos a un Arbitraje de Equidad de la Corte de Arbitraje de las
				Cámaras de Comercio e Industria. En este sentido, y de acuerdo con la
				normativa aplicable, {siteName} informa de la existencia de una
				plataforma europea de resolución de litigios en línea que facilita la
				resolución extrajudicial de dichos litigios para contratos también celebrados
				en línea entre consumidores y proveedores de servicios de Internet. Se puede
				acceder a esta plataforma a través del siguiente sitio web:
				<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
			</p>
			<h3>13. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL</h3>
			<p>
				El Sitio Web y sus contenidos están sujetos a protección en aplicación de la
				normativa nacional vigente en materia de Propiedad Intelectual y/o Industrial,
				así como en aplicación de los convenios internacionales aplicables en esta
				materia. {siteName} es titular o ha licenciado debidamente todos los
				derechos de Propiedad Intelectual e Industrial sobre el Sitio Web y sus
				contenidos.
			</p>
			<p>
				Cualquier forma de reproducción, distribución, comunicación pública,
				transformación, puesta a disposición y, en general, cualquier otro acto de
				explotación con fines o no comerciales del Sitio Web o de sus contenidos, sin
				el previo consentimiento expreso de {siteName}. Queda expresamente
				prohibido borrar los datos identificativos de {siteName} como titular
				de los derechos de Propiedad Intelectual e Industrial del Sitio Web o de sus
				contenidos.
			</p>
			<p>
				{siteName} se reserva todos los derechos de Propiedad Intelectual e
				Industrial sobre el Sitio Web y sus contenidos, reservándose además el
				ejercicio de cuantas acciones legales le correspondan con el fin de cesar,
				impedir o perseguir cualquier utilización ilícita del Sitio Web o de sus
				contenidos. En ningún caso y bajo ninguna circunstancia el acceso al Sitio Web
				o su utilización por parte del Usuario o de terceros constituye ni supone una
				cesión de ningún tipo por parte de {siteName} de los derechos de
				Propiedad Intelectual o Industrial del Sitio Web o de sus contenidos. En
				ningún caso la falta de exigencia por parte de {siteName} de cesar en
				el uso del Sitio Web o de sus contenidos ilícitos o contrarios a las presentes
				condiciones podrá entenderse como consentimiento tácito por parte de {siteName}
				 a tales usos o como una renuncia al ejercicio de cualquier acción
				legal que pudiera corresponderle.
			</p>
			<h3>14. RESPONSABILIDADES Y GARANTÍAS</h3>
			<p>
				El Usuario deberá utilizar el Sitio Web y sus contenidos de conformidad con
				las lo dispuesto en las presentes condiciones de uso, la legislación vigente y
				la buena fe. Cualquier uso del sitio web o de sus contenidos contrario a las
				presentes condiciones generales, el Queda expresamente prohibida la ley o la
				buena fe, independientemente de que dicho uso haya sido un fin económico o
				no.<br />
				El Usuario será responsable de cualquier daño o perjuicio que cause a {siteName}
				 o a terceros derivados directa o indirectamente de cualquier uso
				que el Usuario haga del Sitio Web o de sus contenidos contrarios a las
				presentes condiciones, la ley, la moral, el orden público o la buena fe.
			</p>
			<p>
				Para que el Sitio Web y sus contenidos sean accesibles para el Usuario,
				{siteName} requiere servicios proporcionados por terceros. Es
				posible que a pesar de los esfuerzos realizados por {siteName} para
				mantener el sitio web disponible y accesible a los usuarios, su disponibilidad
				podrá ser suspendida, interrumpida o cancelado por motivos ajenos a {siteName}. 
				Por eso {siteName} no garantiza la inexistencia de interrupciones o
				errores en el acceso al Sitio Web o sus contenidos, ni que se encuentren
				actualizados o mostrados siempre en su última versión. En consecuencia, {siteName}
				 rechaza cualquier responsabilidad por los daños y perjuicios que
				pudieran derivarse al Usuario o a terceros como como consecuencia de la
				suspensión, interrupción, falta de continuidad, corte de la red o desconexión
				del Sitio Web.
			</p>
			<p>
				En ningún caso y bajo ninguna circunstancia {siteName} será responsable
				de daños o perjuicios derivados al usuario por causas no imputables a {siteName}
				 tales como, a título enunciativo y en ningún caso limitativo,
				naturales catástrofes, situaciones de fuerza mayor o extrema urgencia, virus,
				daños componentes, mal funcionamiento del navegador, caídas de la red,
				intrusiones informáticas o ataques de terceros.
			</p>
			<h3>15. ENLACES</h3>
			<p>
				Los sitios web, plataformas, foros, chats, blogs o redes sociales externas que
				enlace o enlace al Sitio Web deberá informar claramente que no tiene la
				autorización o supervisión de {siteName} y que dicho enlace o El
				enlace no supone, supone ni implica asociación de ningún tipo entre {siteName} 
				y los sitios web, plataformas, foros, chats, blogs o externos.
				Redes sociales que enlazan o enlazan con el Sitio Web.
			</p>
			<p>
				En todo caso, cualquier enlace que se dirija al Sitio Web deberá dirigirse
				directamente a la página de inicio o página de inicio del Sitio Web haciendo
				clic en la URL del sitio web abarcando toda la pantalla de la página de inicio
				o página de inicio de el Sitio Web, para que el enlace sea absoluto y completo
				sin el uso de marcos, marcos o hipervínculos. {siteName} no responde en
				ningún caso y en ningún caso al contenido, información o datos relacionados
				con el sitio web, su contenido o cualquier otro asunto contenido en los sitios
				web, plataformas, foros, chats, blogs o redes sociales de terceros que enlacen
				o enlacen con el Sitio web.
			</p>
			<p>
				Queda expresamente prohibido enlazar o enlazar al Sitio Web desde sitios web,
				plataformas, foros, chats, blogs o redes sociales contrarios a la ley, a la
				moral y buenas costumbres, especialmente aquellas con carácter pornográfico,
				ilícito, ilegal o contenido que infrinja los derechos humanos.
			</p>
			<p>
				Por otro lado, el Sitio Web puede contener enlaces a sitios web de terceros,
				plataformas, foros, chats, blogs o redes sociales. {siteName} no dispone
				de los medios humanos y/o técnicos para conocer o controlar la información y
				Contenido que aparece en sitios web de terceros. Por lo tanto, en ningún caso
				{siteName} será responsable del contenido de los sitios
				enlazados y bajo ningún concepto circunstancias podrán considerarse dichos
				enlaces como efectivo conocimiento del contenido de los sitios a los que
				enlazan.
			</p>
			<h3>16. PROTECCIÓN DE DATOS</h3>
			<p>
				Tal y como establece su {privacyPolicyLink}, {siteName} se compromete a
				utilizar los datos del Usuario, a respetar su confidencialidad y a utilizarlos
				de acuerdo con la finalidad del tratamiento, así como a cumplir con su
				obligación. para salvarlo. y adaptará todas las medidas para evitar su
				alteración, pérdida, tratamiento o acceso no autorizado de acuerdo con lo
				dispuesto en la legislación vigente en materia de protección de datos de
				carácter personal.
			</p>
			<p>
				El Sitio Web incorpora medidas de seguridad adecuadas y utiliza tecnología
				estándar del sector para mejorar la seguridad , integridad, integridad,
				exactitud y protección de los datos personales que ha recopilado, y ha
				establecido precauciones razonables para proteger esa información de una
				posible pérdida o uso indebido. Sus normas en materia de protección y
				seguridad de datos son revisadas periódicamente y mejoradas cuando es
				necesario, y se esfuerza para que sólo las personas autorizadas puedan acceder
				a la información proporcionada por el Usuario.
			</p>
			<p>
				Para conocer más sobre la gestión y tratamiento de sus datos realizado por {siteName},
				lea nuestra {privacyPolicyLink} y nuestra {cookiesPolicyLink}.
			</p>
			<h3>17. DURACIÓN Y MODIFICACIÓN</h3>
			<p>
				Las presentes condiciones de uso estarán vigentes mientras estén expuestas a
				los usuarios, por lo que en cuanto sean modificadas o actualizadas total o
				parcialmente, estas condiciones dejarán de estar vigentes. , siendo las nuevas
				condiciones de uso las que pasan a regular el uso del Sitio Web.
			</p>
			<p>
				{siteName} se reserva el derecho de revisar, modificar o actualizar
				estas condiciones de uso en cualquier momento. En caso de cualquier cambio en
				estas condiciones de uso por cualquier motivo, {siteName} notificará a
				los usuarios en la página de inicio de la web sobre dicha circunstancia para
				que queden debidamente informados y puedan consultar las revisiones,
				modificaciones o actualizaciones de las presentes condiciones de Úselo a su
				satisfacción.
			</p>
			<h3>18. GENERAL</h3>
			<p>
				En ningún caso y bajo ninguna circunstancia la falta de ejercicio de sus
				derechos por parte de {siteName} podrá entenderse como una renuncia a
				los mismos.
			</p>
			<p>
				Los encabezados contenidos en estas condiciones son meramente orientativos. o
				informativas, de manera que no afecten, califiquen o amplíen la interpretación
				de las mismas.
			</p>
			<p>
				En el caso de que cualquiera de las cláusulas contenidas en estas condiciones
				fuera declarada nula, abusiva o inaplicable, total o parcialmente, por un
				órgano judicial o administrativo, dicha declaración afectará individualmente a
				la cláusula de que se trate, teniéndola por no y sin que la declaración de
				nulidad, abuso o inaplicabilidad pueda extenderse en ningún caso al resto de
				las condiciones, que subsistirán.
			</p>
			<p>
				Las presentes condiciones de uso, así como la {privacyPolicyLink} y las
				{cookiesPolicyLink} se rigen por la normativa española vigente en cada
				momento.
			</p>
			<h3>19. ATENCIÓN AL CLIENTE</h3>
			<p>
				Para cualquier aclaración, incidencia o reclamación, puede contactar con
				nosotros a través de:<br />
				E-mail: {supportLink}<br />
				Dirección postal: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España.
			</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Última actualización: 10 de junio de 2024',
		content: `
			<h3>1. Parte responsable y descripción</h3>
			<h5>1.1. Responsable</h5>
			<p>La persona responsable del tratamiento de este sitio es Remove Background S.L (en adelante, Remove Background o el Servicio), con dirección en Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España.</p>
			<p>NIF: B56768260<br> Email: {supportLink}</p>
			<h5>1.2. Descripción</h5>
			<p>La aceptación de la política de privacidad de Remove Background (en adelante, "Política de Privacidad"), es una condición necesaria para el uso de nuestro sitio web y la prestación del servicio (en adelante, el "Servicio").<br>
				Esta Política de Privacidad regula la recolección, tratamiento y uso de su información personal y no personal como usuario de Remove Background, a partir de la fecha de efectividad que aparece en el encabezado.<br>
				Para procesar sus datos personales, Remove Background cumple con la legislación local y europea vigente, así como con sus regulaciones de implementación.</p>
			<h3>2. Información recopilada</h3>
			<p>El acceso a nuestro sitio web se puede realizar sin necesidad de proporcionar ninguna información, aunque para registrarse y/o contratar nuestros planes necesitará proporcionarnos alguna información personal. La información (personal o no personal) recopilada por el Servicio puede variar en función de ello.<br>
				La información personal y no personal recopilada por el Servicio nos llegará de tres maneras: 1) la que se recopila automáticamente 2) la que usted nos proporciona voluntariamente y 3) la que proporcionan terceros.</p>
			<h5>2.1. La que se recopila automáticamente</h5>
			<p>Esta información consistirá en:</p>
			<ul>
				<li>La recopilada a través de cookies o mecanismos similares almacenados en su dispositivo, siempre con su consentimiento o de acuerdo con otras bases legales. Consulte nuestra Política de Cookies para más información.</li>
				<li>La IP desde la que se realiza la conexión, el tipo de dispositivo utilizado y sus características, la versión del sistema operativo, el tipo de navegador, el idioma, la fecha, el país, la hora de la solicitud, la URL desde la que viene, la URL a la que va o la red móvil utilizada, entre otros.</li>
				<li>Datos de uso del servicio y posibles errores detectados durante su uso.</li>
				<li>Además, Remove Background utiliza Google Analytics, un servicio analítico proporcionado por Google, LLC. domiciliado en los Estados Unidos con sede en 1600 Amphitheater Parkway, Mountain View, California 94043. Para la prestación de estos servicios, utilizan cookies que recopilan información, incluida la dirección IP del usuario, que será transmitida, procesada y almacenada por Google en los términos establecidos en la web www.google.com. Incluyendo la posible transmisión de dicha información a terceros por razones de requerimiento legal o cuando dichos terceros procesen la información en nombre de Google.</li>
			</ul>
			<p>En cualquier caso, puede desactivar las cookies de Google Analytics desde <a href="{disableGoogleAnalyticsLink}">aquí</a>.</p>
			<h5>2.2. La que usted proporciona voluntariamente</h5>
			<p>Esta información consistirá en:</p>
			<ul>
				<li>Todos los datos son obligatorios.</li>
				<li>La requerida por Remove Background para completar su registro en la web: nombre y apellidos, dirección y correo electrónico, entre otros.</li>
				<li>Todos los datos son obligatorios.</li>
				<li>La información, personal o no, para completar la contratación del servicio como su dirección de correo electrónico y su número de tarjeta de crédito o débito.</li>
				<li>La información, personal o no, que los mensajes enviados a través de los canales de contacto u opinión establecidos en el Servicio puedan contener, por ejemplo, su nombre y correo electrónico.</li>
			</ul>
			<h5>2.3. La proporcionada por terceros</h5>
			<p>Esta información consistirá en:</p>
			<ul>
				<li>La proporcionada por sistemas de pago o procesadores de tarjetas de crédito, como el momento de la compra o su monto.</li>
			</ul>
			<h3>3. Derechos y propósitos</h3>
			<p>Le informamos que la cumplimentación de los formularios es voluntaria. Sin embargo, si no completa los campos requeridos 
				(normalmente marcados con un asterisco), el uso de algunas funciones del Servicio no será posible o estará limitado.<br>
				Los datos personales que nos proporcione se incorporarán y tratarán en el Registro de Actividades de Tratamiento de Remove Background 
				con el fin de poder atender sus solicitudes, prestar el servicio solicitado y mantenerle informado sobre asuntos relacionados 
				con la actividad de la empresa y sus servicios.<br>
				Puede ejercer en cualquier momento los derechos de acceso, rectificación, eliminación, limitación de su tratamiento, oposición y 
				portabilidad de sus datos personales mediante un correo electrónico dirigido a: {supportLink} o a la dirección postal: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España.<br>
				En ambos casos, debe identificarse con su nombre y apellidos, así como con una copia de su DNI o identificación nacional, si es necesario.<br>
				En el caso de que haya otorgado consentimiento para un propósito específico, tiene derecho a retirarlo en cualquier momento, 
				sin que ello afecte a la legalidad del tratamiento basado en el consentimiento previo a su retirada.</br>
				Además, si considera que hay un problema con la forma en que Remove Background está manejando sus datos, puede dirigir sus quejas a la 
				<a href="{knowYourRightsLink}">autoridad de protección de datos</a> correspondiente, siendo la <a href="{aepdLink}">Agencia Española 
				de Protección de Datos</a> la indicada en el caso de España.</p>
			<h3>4. Edad</h3>
			<p>Con respecto al uso del servicio en línea, declara que es mayor de edad y que tiene la capacidad legal necesaria para vincularse a este acuerdo y utilizar el sitio de acuerdo con sus términos y condiciones, que comprende y reconoce plenamente.<br>
				Declara que toda la información que proporciona para acceder al Servicio, antes y durante su uso, es verdadera, completa y precisa.</p>
			<h3>5. Uso de datos</h3>
			<p>Remove Background utilizará los datos recopilados para:</p>
			<ul>
				<li>Gestionar y actualizar el Servicio (la base legal es nuestro interés legítimo en mantener y actualizar el Servicio en buen estado).</li>
				<li>Atender las preguntas que plantee (la base legal es nuestro interés legítimo en atender las solicitudes y dudas de nuestros usuarios).</li>
				<li>Procesar los pagos que realice (el contrato siendo la base legal).</li>
				<li>Proporcionar el servicio contratado (el contrato siendo la base legal).</li>
				<li>Mantener la seguridad del Servicio, investigar actividades ilegales, hacer cumplir nuestros términos y condiciones y ayudar a las fuerzas de seguridad del estado en el marco de sus posibles investigaciones (la base legal es nuestro interés legítimo en garantizar y mantener la seguridad del Servicio y sus usuarios).</li>
			</ul>
			<p>Remove Background no utiliza decisiones automatizadas, aunque puede generar perfiles básicos de usuario, la base legal es nuestro interés legítimo para fines comerciales y ofrecer ofertas personalizadas.<br>
			Además, Remove Background puede utilizar la información del usuario en forma de datos agregados y anónimos para mostrarla a terceros. También puede compartir estadísticas e información demográfica sobre los usuarios y su uso del Servicio con terceros. Pero ninguno de estos permitirá que esos terceros lo identifiquen personalmente.</p>
			<h5>5.1. En correos electrónicos y formularios de contacto</h5>
			<p>El sitio web cuenta con un cifrado SSL que permite al usuario enviar sus datos personales de forma segura a través de formularios de contacto estándar.<br>
				Los datos personales recopilados estarán sujetos a tratamiento automatizado e incorporados a los archivos correspondientes del registro de actividades de tratamiento de los que Remove Background es propietario.</p>
			<p>En ese sentido:</p>
			<ul>
				<li>Recibiremos su dirección IP, que se utilizará para verificar el origen del mensaje con el fin de ofrecerle recomendaciones adecuadas (por ejemplo, presentar la información en el idioma correcto) y para detectar posibles irregularidades (por ejemplo, posibles intentos de ciberataque al Servicio), así como datos relacionados con su ISP.</li>
				<li>Asimismo, puede proporcionarnos sus datos por teléfono, correo electrónico y otros medios de comunicación indicados.</li>
			</ul>
			<p>Con respecto a los medios de pago utilizados:</p>
			<ul>
				<li>Nuestros proveedores de servicios de pago para el pago de la prestación de nuestros servicios son tarjeta de crédito o débito. En ningún momento el Servicio o su personal tendrá acceso a los datos bancarios (por ejemplo, el número de tarjeta de crédito) que el usuario como cliente proporcionará a esos terceros.</li>
			</ul>
			<h3>6. Retención de datos</h3>
			<p>A continuación, se indican durante cuánto tiempo se conservan los datos tratados por el Servicio:</p>
			<ul>
				<li>Los datos desagregados se conservarán sin período de eliminación.</li>
				<li>
					Los datos de clientes se conservarán por el mínimo necesario, pudiendo mantenerse hasta:
					<ul>
						<li>5 años, según el art. 1964 del Código Civil (acciones personales sin término especial).</li>
						<li>6 años, según el art. 30 del Código de Comercio (libros de contabilidad o facturas, por ejemplo).</li>
					</ul>
				</li>
				<li>Los datos de usuarios se conservarán por un período máximo de 12 meses para poder atender sus solicitudes.</li>
			</ul>
			<h3>7. Datos compartidos con terceros</h3>
			<p>Existen terceros que gestionan parte del Servicio.<br>
				Remove Background les exige que cumplan con esta Política de Privacidad según sea aplicable, además de tener la suya propia. Sin embargo, Remove Background no será responsable del cumplimiento de dicha política.<br>
				Bajo algunas circunstancias, Remove Background puede compartir, utilizar o preservar con terceros cualquiera de la información personal recopilada:</p>
			<ul>
				<li>Para prestar el Servicio:</li>
			</ul>
			<p>Proveedores de servicios que realizan funciones en nuestro nombre, como servicios de pago, alojamiento web, análisis comercial, servicio al cliente o marketing web. Estos proveedores de servicios pueden recopilar y tener acceso a la información que es necesaria para que realicen sus funciones, pero no se les permite compartir o usar la información para ningún otro propósito.</p>
			<ul>
				<li>Para cooperar con las autoridades competentes:</li>
			</ul>
			<p>Si creemos que es razonablemente necesario para cumplir con cualquier ley, proceso legal o interés legítimo. En cualquier caso, solo proporcionaremos la información estrictamente requerida.</p>
			<h3>8. Medidas de seguridad</h3>
			<p>Remove Background adopta todas las medidas técnicas y organizativas necesarias para proteger la seguridad e integridad de la información personal y no personal recopilada. Tanto contra el acceso no autorizado como contra su alteración accidental, pérdida o destrucción.<br>
				En cualquier caso, Remove Background no puede garantizar la seguridad absoluta de la información recopilada, por lo que debe colaborar y usar el sentido común sobre la información compartida en todo momento.<br>
				Usted comprende y reconoce que, incluso después de la eliminación, la información personal y no personal puede permanecer visible en caché o si otros usuarios la han copiado o almacenado.</p>
			<h3>9. Cambios en la Política de Privacidad</h3>
			<p>Podemos actualizar esta Política de Privacidad en el futuro. Le informaremos de sus cambios enviando un aviso a la dirección de correo electrónico proporcionada y/o colocando un aviso en un lugar destacado de nuestro sitio web.</p>
			<h3>10. Contacto</h3>
			<p>Si tiene preguntas sobre esta Política de Privacidad, contáctenos en:</p>
			<p>Email: {supportLink}<br>
			Dirección: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España.</p>
		`
	},

	gdpr: {
		lastUpdate: 'Última actualización: 10 de junio de 2024',
		content: `
			<h3>1. ¿Quién es responsable y cómo contactarlo?</h3>
			<p>El controlador de este sitio es Remove Background S.L con dirección en Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España.</p>
			<p>Puede contactarlo por correo electrónico en {supportLink}.</p>
			<h3>2. ¿Qué datos se recogen?</h3>
			<p>
			Recogemos automáticamente datos a través de las cookies que cargamos en su dispositivo, incluyendo analíticas. 
			También recopilamos la IP desde la que se realiza la conexión, el tipo de dispositivo utilizado y sus características, 
			la versión del sistema operativo, el tipo de navegador, el idioma, la fecha, el país, la hora de la solicitud, 
			la URL desde la que proviene, la URL a la que va o la red móvil utilizada, entre otros.<br>
			Voluntariamente, el usuario nos proporciona información como su nombre y apellido, correo electrónico o información bancaria 
			para poder contactarnos, registrarse en el servicio o comprar una suscripción.
			</p>
			<h3>3. ¿Para qué se utilizan los datos recogidos?</h3>
			<p>
			El Servicio utilizará los datos recogidos, entre otras cosas, para administrar y actualizar el servicio, responder a sus solicitudes, 
			enviarle nuestro boletín informativo y ofertas promocionales por correo electrónico, gestionar su registro en la plataforma, gestionar y proporcionar 
			los servicios relacionados con su suscripción, procesar los pagos que realice y emitir las correspondientes facturas, 
			mantener la seguridad del Servicio, investigar actividades ilícitas, hacer cumplir nuestros términos y condiciones y 
			ayudar a las fuerzas y cuerpos de seguridad del estado en el marco de sus eventuales investigaciones.
			</p>
			<h3>4. ¿Cuánto tiempo se conservan?</h3>
			<ul>
			<li>Los datos desagregados se conservarán sin período de eliminación.</li>
			<li>
				Los datos de los clientes se conservarán por el mínimo necesario y podrán conservarse hasta:
				<ul>
					<li>5 años, según el art. 1964 del Código Civil (acciones personales sin término especial).</li>
					<li>6 años, según el art. 30 del Código de Comercio (libros de contabilidad o facturas, por ejemplo).</li>
				</ul>
			</li>
			<li>Los datos de los usuarios se conservarán por un período máximo de 12 meses para atender sus solicitudes.</li>
			<li>Los datos de los usuarios subidos por el Servicio a páginas y perfiles en redes sociales se conservarán desde el momento en que el usuario ofrezca su consentimiento hasta que lo retire.</li>
			</ul>
			<h3>5. ¿Cuáles son sus derechos como usuario?</h3>
			<p>
			Derecho de acceso: El interesado tendrá derecho a obtener confirmación del responsable del tratamiento sobre si se están tratando o no datos personales que le conciernen.
			</p>
			<p>
			Derecho de rectificación: el interesado tendrá derecho a obtener, sin dilación indebida, del responsable del tratamiento la rectificación de los datos personales inexactos que le conciernan directamente. Asimismo, el interesado tendrá 
			derecho a completar los datos personales incompletos, inclusive mediante una declaración adicional.
			</p>
			<p>
			Derecho de supresión: Es el derecho del interesado a obtener, sin dilación indebida, del responsable del tratamiento la supresión de los datos personales que le conciernan.
			</p>
			<p>
			Derecho a la limitación del tratamiento: consiste en obtener la limitación del tratamiento de sus datos por parte del responsable, 
			aunque su ejercicio tiene dos vertientes: 1) Cuando impugna la exactitud de sus datos personales, durante un período que permita 
			al responsable su verificación y 2) Cuando se haya opuesto al tratamiento de sus datos personales que realiza el responsable 
			con base en interés legítimo o misión de interés público, mientras el responsable verifica si estos motivos prevalecen sobre los suyos.
			</p>
			<p>
			Derecho a la portabilidad de los datos: Es el derecho del interesado a recibir los datos personales que le incumban, 
			que haya proporcionado a un responsable del tratamiento, en un formato estructurado, de uso común y lectura mecánica, y 
			a transmitirlos a otro responsable del tratamiento sin que lo impida el responsable al que se los hubiera facilitado.
			</p>
			<p>
			En este sentido, el interesado tendrá derecho a que los datos personales se transmitan directamente de responsable a responsable cuando sea técnicamente posible.
			</p>
			<h3>6. ¿Cómo puede ejercer sus derechos?</h3>
			<p>
			Puede ejercer sus derechos de protección de datos personales en cualquier momento enviando un correo electrónico a: {supportLink} o a la dirección postal: 
			Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, España. En ambos casos, debe identificarse con su nombre y apellidos, 
			así como una copia de su DNI o documento de identidad nacional, si fuera necesario.<br>
			Además, si considera que hay un problema con la forma en que Remove Background está manejando sus datos, puede dirigir sus reclamaciones 
			a la <a href="{knowYourRightsLink}">autoridad de protección de datos</a> que corresponda, siendo la <a href="{aepdLink}">Agencia Española de Protección de Datos</a> 
			la indicada en el caso de España.
			</p>
			<h3>7. ¿Se adoptan medidas de seguridad?</h3>
			<p>
			El Servicio toma todas las medidas técnicas y organizativas necesarias para proteger la seguridad e integridad de la información personal 
			y no personal recopilada. Tanto contra el acceso no autorizado como contra la alteración, pérdida o destrucción accidental.<br>
			En cualquier caso, el Servicio no puede garantizar la seguridad absoluta de la información recopilada, por lo que debe colaborar y 
			usar el sentido común en todo momento respecto a la información compartida.<br>
			Usted entiende y reconoce que, incluso después de la eliminación, la Información Personal y No Personal puede seguir siendo visible en la caché o 
			si otros usuarios la han copiado o almacenado.
			</p>
			<h3>8. ¿Hay transferencias de datos personales o transferencias internacionales?</h3>
			<p>
			No realizamos transferencias de datos ni transferencias internacionales. Sin embargo, hay terceros que gestionan parte del Servicio 
			a quienes requerimos cumplir con nuestra Política de Privacidad en la medida en que les sea aplicable y que tienen la suya propia. 
			Estos terceros son proveedores de servicios que realizan funciones en nuestro nombre, como alojamiento web, 
			monitoreo de análisis o desarrollo web.<br>
			Asimismo, si creemos que es razonablemente necesario para cumplir con cualquier ley, proceso legal o interés legítimo. 
			En cualquier caso, solo proporcionaremos la información estrictamente requerida.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Última actualización: 21 de junio de 2024',
		content: `
			<h3>Sumario</h3>
			<ul>
				<li>Cookies usadas: <strong>Propias y de Terceros</strong></li>
				<li>¿Se usan para obtener estadísticas? <strong>Sí, siendo la base legal nuestro interés legítimo en realizar una mejor gestión del servicio.</strong></li>
				<li>Servicios de terceros que instalan cookies a través de esta web: <strong>Google, Google Analytics, Cloudflare y Stripe.</strong></li>
			</ul>

			<h3>Cómo configurar y deshabilitar las cookies</h3>
			<p>
				Puedes permitir, bloquear o eliminar las cookies instaladas en tu dispositivo desde tu navegador web. Si no permites la instalación de cookies en tu dispositivo, 
				puede que la experiencia de navegación empeore. A continuación, puedes encontrar cómo configurar las cookies en cada navegador:
			</p>
			<ul>
				<li><a href="{externalLink: edgeCookies}">Edge</a></li>
				<li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
				<li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
				<li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
				<li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
				<li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
				<li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
				<li><a href="{externalLink: operaCookies}">Opera</a></li>
				<li><a href="{externalLink: safariCookies}">Safari</a></li>
				<li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Tipos y usos</h3>
			<p>El servicio usa cookies propias y de terceros para mejorar la navegación, proporcionar el servicio y obtener estadísticas sobre el uso de la página web.</p>

			<h3>2. ¿Qué es una cookie y para qué sirve?</h3>
			<p>
				Una cookie es un fichero de texto que se envía al navegador web de tu ordenador, móvil o tablet y que sirve para almacenar y recuperar información sobre
				la navegación realizada. Por ejemplo, recordar tu nombre de usuario y contraseña o las preferencias de tu perfil.
			</p>

			<h3>3. ¿Qué tipos de cookies hay?</h3>
			<p>Según quién las gestiona:</p>
			<ul>
				<li>Cookies propias; se envían a tu navegador desde nuestros equipos o dominios web.</li>
				<li>Cookies de terceros; se envían a tu navegador desde un equipo o dominio web que no gestionamos nosotros directamente, sino una tercera entidad como por ejemplo Google.</li>
			</ul>
			<p>En función del tiempo que están activas, hay:</p>
			<ul>
				<li>Cookies de sesión; permanecen en el archivo de cookies de tu navegador hasta que abandonas la página web, de modo que ninguna queda en tu dispositivo.</li>
				<li>Cookies persistentes; permanecen en tu dispositivo y nuestra web las lee cada vez que realizas una nueva visita. Estas cookies dejan de funcionar pasada una fecha concreta.</li>
			</ul>
			<p>Finalmente, y según su finalidad, tenemos:</p>
			<ul>
				<li>Cookies técnicas; mejoran la navegación y el buen funcionamiento de la web.</li>
				<li>Cookies de personalización; permiten acceder al servicio con unas características predefinidas en función de una serie de criterios.</li>
				<li>Cookies de análisis; permiten medir y analizar estadísticamente el uso que se hace del servicio prestado.</li>
			</ul>
			<p>Lista de cookies de tercero usadas por <strong>remove-background.com</strong></p>
			<ul>
				<li> 
					<a href="{externalLink: googleCookiesPolicy}">Google</a>:  Sus cookies (NID o CONSENT) permiten personalizar cómo se ven anuncios fuera de Google o almacenar información 
					como el idioma preferido a la hora de mostrar resultados de búsqueda.<br><a href="{externalLink: googleCookieTypes}">Más información</a> sobre los tipos de cookies que usa Google en sus múltiples servicios.
				</li>
				<li>
					<a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Sus cookies (como por ejemplo _ga) permiten contabilizar las veces que un usuario visita una web, cómo, cuándo y desde dónde lo hace.<br>
					En cualquier caso, puedes inhabilitar las cookies de Google Analytics desde <a href="{externalLink: disableGoogleAnalytics}">aquí</a>.
				</li>
				<li>Cloudflare: Para conocer sobre la política y uso de cookies de Cloudflare haz click en <a href="{externalLink: cloudflareCookiesPolicy}">este enlace</a>.</li>
				<li>Stripe: Encuentra información <a href="{externalLink: stripeCookiesPolicy}">aquí</a> sobre la política y uso de cookies en Stripe.</li>
			</ul>
		`
	}
};
